/** Standard HTML layer font size in cqh units (container-query height %). */
export const HTML_BASE_FONT_CQH = 2;

/** Absolute cqh stored in event settings at “1.0×” (standard). stored = UI × 2 */
export const DEFAULT_FONT_SIZE_CQH = HTML_BASE_FONT_CQH;

/** Relative UI range mapped onto absolute cqh via BASE. */
export const FONT_SIZE_RELATIVE_MIN = 0.5;
export const FONT_SIZE_RELATIVE_MAX = 2;

export const FONT_SIZE_ABSOLUTE_MIN = HTML_BASE_FONT_CQH * FONT_SIZE_RELATIVE_MIN; // 1
export const FONT_SIZE_ABSOLUTE_MAX = HTML_BASE_FONT_CQH * FONT_SIZE_RELATIVE_MAX; // 4

export function clampFontSizeCqh(absoluteCqh: number): number {
  if (!Number.isFinite(absoluteCqh) || absoluteCqh <= 0) return DEFAULT_FONT_SIZE_CQH;
  return Math.min(FONT_SIZE_ABSOLUTE_MAX, Math.max(FONT_SIZE_ABSOLUTE_MIN, absoluteCqh));
}

export function absoluteFontSizeCqhFromRelative(relative: number): number {
  const r = Number.isFinite(relative) ? relative : 1;
  return clampFontSizeCqh(r * HTML_BASE_FONT_CQH);
}

/**
 * Captions and info overlays keep type on the stage. Their box height crops content.
 * Other HTML layers, including virtual-media composites, scale type with the layer box.
 */
export function htmlFontResolvesAgainstStage(layer: { componentId?: string; itemId?: string }): boolean {
  return layer.componentId === 'liveTranslation' || layer.itemId?.startsWith('overlay:') === true;
}

export function relativeFontSizeFromAbsoluteCqh(absoluteCqh: number | undefined | null): number {
  const absolute = absoluteCqh == null || !Number.isFinite(absoluteCqh) ? DEFAULT_FONT_SIZE_CQH : absoluteCqh;
  return clampFontSizeCqh(absolute) / HTML_BASE_FONT_CQH;
}
